export default __webpack_public_path__ + "static/media/threedotimgg.de32576c.svg";